export default __webpack_public_path__ + "static/media/large.25e457bf.jpg";